<template>
  <div />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { name as storeModuleName } from '@/store/modules/app';
const PHONE_TABLE_SIZE = '(min-width: 769px)';

export default {
  computed: {
    ...mapGetters({
      isMobile: 'getIsMobileDensity',
    }),
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    ...mapMutations(storeModuleName, ['setIsMobileDensity']),
    handleResize() {
      const mq = window.matchMedia(PHONE_TABLE_SIZE);
      if (mq.matches) {
        this.setIsMobileDensity(false);
        this.setOpenCaseList(false);
      } else {
        this.setIsMobileDensity(true);
      }
    },
  },
};
</script>
